import { QuantidadeCnpjsVinculadosDTO } from "src/app/sitfis/components/cnpjs-vinculados/model/cnpjs-vinculados";

export const QUANTIDADE_CNPJS_VINCULADOS_DTO: QuantidadeCnpjsVinculadosDTO[] = [
  {
    "tipoParticipacao": "Responsável",
    "quantidade": 1
  },
  {
    "tipoParticipacao": "Responsável",
    "quantidade": 0
  },
  {
    "tipoParticipacao": "Sócio",
    "quantidade": 1
  },
  {
    "tipoParticipacao": "Sócio",
    "quantidade": 0
  }
];